import React from 'react';
import { useLocation } from 'react-router-dom';
import * as styles from './ForbiddenPage.scss';

/**
 * 403 Route Page
 * @function ForbiddenPage
 * @param {Object} props
 * @return {ReactElement}
 */
const ForbiddenPage = () => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const message = query.get('message');
  const redirect = query.get('redirect_to');
  const redirectTitle = query.get('redirect_to_title');

  return (
    <div className={styles.forbiddenPage}>
      <div className={styles.messageContainer}>
        <span className={styles.title}>Error 403 Forbidden</span>
        <span className={styles.subtitle}>{message}</span>
        {(redirect && redirectTitle) &&
        <a className={styles.link} href={redirect}>{redirectTitle}</a>}
      </div>
    </div>
  );
};

export default ForbiddenPage;
